import { TextInput } from '@mantine/core'
import {
  UseFormReturnType,
} from '@mantine/form'

import {
  DirtyFieldLabel,
  TooltipInfoProps,
} from './dirty-field'

import {
  isFieldDirty,
} from './form-dirty-utils'
import React from 'react'

interface DirtyTextInputProps<
  T extends Record<string, any>,
> extends Omit<
  React.ComponentProps<typeof TextInput>,
  'form' | 'label'
>, TooltipInfoProps {
  form: UseFormReturnType<T>
  field: keyof T
  label: string
  tooltip?: string
}

export function DirtyTextInput<
  T extends Record<string, any>
>({
    form,
    field,
    label,
    tooltip,
    ...props
  }: DirtyTextInputProps<T>) {
  return (
    <TextInput
      label={
        <DirtyFieldLabel
          label={label}
          tooltip={tooltip}
          changed={isFieldDirty(
            form,
            field,
          )}
        />
      }
      {...form.getInputProps(
        field as string,
      )}
      {...props}
    />
  )
}